import styled from 'styled-components';

import { DefaultButtonStyled } from '@/components/atom/buttons/DefaultButton';
import AppContainer from '@/components/molecules/AppContainer';
import AppHeader from '@/components/molecules/AppHeader';
import useCustomRouter from '@/hooks/useCustomRouter';
import { ROUTES } from '@/types/common';
import { historyBack } from '@/utils/mobile/RNPlugins';

interface Props {
  title: string;
}
const DeletedPostItem = ({ title }: Props) => {
  const { moveToPage } = useCustomRouter();

  const onClickList = () => {
    moveToPage({
      webLink: ROUTES.COMMUNITY.LIST.path,
      mobileScreenName: ROUTES.COMMUNITY.LIST.appScreenName,
    });
  };

  return (
    <Container>
      <AppHeader title={title} onClickBackButton={historyBack} />
      <Wrapper>
        <Title>신고로 인해 삭제 처리된 게시글입니다.</Title>
        <SubTitle>많은 사용자의 신고로 인해 삭제된 게시글입니다.</SubTitle>
        <Button onClick={onClickList}>목록으로 돌아가기</Button>
      </Wrapper>
    </Container>
  );
};

export default DeletedPostItem;

const Container = styled(AppContainer)`
  min-height: 100vh;
  ${({ theme }) => `
    background: ${theme.color.gray30};
  `};
`;

const Wrapper = styled.div`
  padding: 24px;
  ${({ theme }) => `
    background: ${theme.color.white};
  `};
`;
const Title = styled.div`
  ${({ theme }) => `
    ${theme.typography.UI24SB};
    color: ${theme.color.gray800};
  `};
`;

const SubTitle = styled.div`
  margin: 16px 0;

  ${({ theme }) => `
    ${theme.typography.ARTICLE16R};
    color: ${theme.color.gray600};
  `};
`;

const Button = styled(DefaultButtonStyled)`
  width: 100%;
  padding: 14px;
  border-radius: 8px;

  ${({ theme }) => `
    ${theme.typography.UI14M};
    color: ${theme.color.gray600};
    background: ${theme.color.gray20};
    border: 1px solid ${theme.color.gray100};

    &:active {
      background: ${theme.color.gray50};
    }
  `};
`;
